import { SVG, SVGProps } from './svg'

export function IconDraw(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 3a1 1 0 0 0-.6.2l-8 6.7a.5.5 0 0 0 0 .8l5 4.9a.5.5 0 0 0 .7 0l6.7-8c.3-.4.3-1 0-1.4l-3-3A1 1 0 0 0 17 3Zm0 2.4L18.6 7l-5 6-2.6-2.6 6-5ZM6.5 11.9c.2-.2.5-.2.7 0l5 5v.6l-2.3 2.2a1 1 0 0 1-.7.3H8.1a1 1 0 0 1-.7-.3l-.3-.3-1.3 1.3a1 1 0 0 1-.7.3H2.5a.5.5 0 0 1-.4-.9L5 17.3l-.6-.6a1 1 0 0 1-.3-.6v-1.5c0-.2.1-.5.3-.7l2-2Z"
      />
    </SVG>
  )
}
